import React, {Fragment, useState} from 'react';

import {Dialog, Button} from '@material-ui/core';
import {CloseIcon, RejectIcon, TimesIcon} from "../../../elements/svgIcons";
import {isMobileBrowser} from "../../../vendors/utils/common";

interface Props {
    icon?: string | undefined,
    title?: any,
    description?: any,
    open?: boolean,
    cancelable: {
        buttonTitle: string,
        action?: any
    } | undefined,
    submit?: {
        buttonTitle: string,
        action: any,
        disabled?: boolean
    } | undefined,
    iconIsVisible?: boolean,
    mainBtnColor?: 'primary' | 'secondary' | 'default' | 'inherit',
    secondaryBtnColor?: 'primary' | 'secondary' | 'default' | 'inherit',
    // Form fields belong here rather than inside `description`, which renders in a <p>.
    children?: React.ReactNode
}

const icons: {
    [key: string]: any
} = {
    times:<TimesIcon className="d-flex align-self-center"/>
};

const DangerModal = (props: Props) => {
    const {icon,
        title,
        description,
        open = false,
        cancelable,
        submit,
        iconIsVisible = false,
        mainBtnColor = 'primary',
        secondaryBtnColor = 'default',
        children} = props;
    const [modal, setModal] = useState(open);
    const toggle = () => setModal(!modal);

    return (
        <Fragment>
            <Dialog className="danger-modal" open={modal} onClose={cancelable?.action || toggle}>
                <CloseIcon onClick={cancelable?.action} className='modal-close'/>
                <div className="modal-container text-center px-3 py-4 p-md-5">
                    <div className="avatar-icon-wrapper rounded-circle m-0">
                        {icon && <div
                            className="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon bg-neutral-danger text-danger m-0">
                            {icons[icon]}
                        </div>}
                    </div>
                    {title && <h4 className="modal-title font-weight-bold mt-4">{title}</h4>}
                    {description && <p className="mb-0 mt-4 text-gray">{description}</p>}
                    {children && <div className="mt-4 text-left">{children}</div>}
                    <div className="pt-4">
                        {submit && <Button
                            onClick={submit.action}
                            disabled={submit.disabled}
                            size={isMobileBrowser() ? 'small' : 'medium'}
                            color={mainBtnColor}
                            variant="contained"
                            className="mx-2 font-weight-normal">
                            {iconIsVisible && <span className="btn-wrapper--icon">
                                <RejectIcon style={{fontSize: '.643rem'}}/>
                            </span>}
                            <span className="btn-wrapper--label">{submit.buttonTitle}</span>
                        </Button>}
                        {cancelable && <Button
                            onClick={cancelable.action}
                            variant="outlined"
                            size={isMobileBrowser() ? 'small' : 'medium'}
                            color={secondaryBtnColor}
                            className={`mx-2 text-${secondaryBtnColor} font-weight-normal`}>
                            <span className="btn-wrapper--label">{cancelable.buttonTitle || 'Cancel'}</span>
                        </Button>}
                    </div>
                </div>
            </Dialog>
        </Fragment>
    );
};

export default DangerModal
